import React from 'react';
import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

import type { CloseDialogProps } from '@/features/common/components/dialogs/common/types';

export const DialogFooter = ({ onClose }: CloseDialogProps) => {
    return (
        <Dialog.Footer>
            <button className="btn btn-primary" onClick={onClose}>
                <FormattedMessage id="intl-msg:vehicle-diagnostics.dialog.close" />
            </button>
        </Dialog.Footer>
    );
};
